import { useRef } from "react";

export default function Hero() {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  return (
    <section className="relative min-h-screen overflow-hidden">
      {/* <div
        className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/heroimage.avif')" }}
      /> */}

        {/* Video background */}
        <div className="absolute inset-0 w-full h-full overflow-hidden">
          <video
            src="/devanantahome.mp4"
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover"
          />
        </div>

        {/* Soft black overlay (almost transparent) */}
        <div className="absolute inset-0 bg-black/25" />
       {/* <div className="absolute inset-0 bg-black/40" /> */}  

      <canvas
        ref={canvasRef}
        className="absolute inset-0 w-full h-full opacity-20"
      />

      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 via-transparent to-emerald-900/20" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-transparent to-black/30" />

      <div className="relative z-10 mt-44 flex min-h-[calc(100vh-180px)]">
        <div className="w-full px-6 md:px-20">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-thin text-white mb-6 leading-tight"
            style={{
              textShadow:
                "0 4px 12px rgba(0,0,0,0.85), 0 0 40px rgba(0,0,0,0.6)",
            }}
          >
            The Future of
            <br />
            <span className="text-white">
              Energy Storage Is Here
            </span>
          </h1>

          <p className="text-xl md:text-2xl lg:text-2xl text-white/95 mb-12 max-w-3xl leading-relaxed font-light tracking-wide"
            style={{
              textShadow:
                "0 3px 10px rgba(0,0,0,0.9)",
            }}
          >
            From waste to watts, batteries that do more for less.
Sustainable materials, superior energy density, real-world cost advantage.
            <br />
            Devananta R&D
          </p>

          {/* <button className="px-12 py-4 bg-gradient-to-r from-blue-600 to-emerald-500 text-white text-lg font-semibold rounded-lg hover:shadow-2xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300 border border-white/20">
            DISCOVER NOW
          </button> */}
        </div>
      </div>
    </section>
  );
}
